import { PACKAGE_TYPES, EMPLOYMENT_TYPES, CURRENCIES } from '../constants/offer';

export default function OfferDetailsForm({ value, onChange, compact = false }) {
  const set = (field, v) => onChange({ ...value, [field]: v });

  const field = (label, children) => (
    <div className={compact ? 'field-with-label' : 'field-with-label'}>
      {children}
      <label>{label}</label>
    </div>
  );

  return (
    <div className={`space-y-3 ${compact ? '' : 'border border-purple-100 bg-purple-50/30 p-3'}`}>
      {!compact && <p className="text-sm font-medium text-[hsl(var(--ds-fg))]">Offer details</p>}
      {field(
        'Designation *',
        <input
          className="h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]"
          value={value.designation}
          onChange={e => set('designation', e.target.value)}
          placeholder=" "
        />
      )}
      {field(
        'Department',
        <input
          className="h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]"
          value={value.department}
          onChange={e => set('department', e.target.value)}
          placeholder=" "
        />
      )}
      <div className="grid grid-cols-2 gap-2">
        {field(
          'Currency',
          <select
            className="h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]"
            value={value.currency}
            onChange={e => set('currency', e.target.value)}
          >
            {CURRENCIES.map(c => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        )}
        {field(
          'Package / CTC *',
          <input
            className="h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]"
            value={value.package}
            onChange={e => set('package', e.target.value)}
            placeholder=" "
          />
        )}
      </div>
      {field(
        'Package type',
        <select
          className="h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]"
          value={value.packageType}
          onChange={e => set('packageType', e.target.value)}
        >
          {PACKAGE_TYPES.map(p => (
            <option key={p.value} value={p.value}>
              {p.label}
            </option>
          ))}
        </select>
      )}
      {field(
        'Expected joining date *',
        <input
          type="date"
          className="h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]"
          value={value.expectedJoiningDate}
          onChange={e => set('expectedJoiningDate', e.target.value)}
        />
      )}
      {field(
        'Work location',
        <input
          className="h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]"
          value={value.workLocation}
          onChange={e => set('workLocation', e.target.value)}
          placeholder=" "
        />
      )}
      {field(
        'Employment type',
        <select
          className="h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]"
          value={value.employmentType}
          onChange={e => set('employmentType', e.target.value)}
        >
          {EMPLOYMENT_TYPES.map(t => (
            <option key={t.value} value={t.value}>
              {t.label}
            </option>
          ))}
        </select>
      )}
      {field(
        'Probation period',
        <input
          className="h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]"
          value={value.probationPeriod}
          onChange={e => set('probationPeriod', e.target.value)}
          placeholder="e.g. 3 months"
        />
      )}
      {field(
        'Benefits',
        <textarea
          className="h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]"
          rows={2}
          value={value.benefits}
          onChange={e => set('benefits', e.target.value)}
          placeholder=" "
        />
      )}
      {field(
        'Additional notes',
        <textarea
          className="h-9 w-full rounded-xl border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3 text-sm text-[hsl(var(--ds-fg))] outline-none hover:border-[hsl(var(--ds-primary)/0.45)] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]"
          rows={2}
          value={value.additionalNotes}
          onChange={e => set('additionalNotes', e.target.value)}
          placeholder=" "
        />
      )}
    </div>
  );
}
